/* Cormo theme script. Small, and the site works without it. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function money(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  // Phone menu: close with Escape.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.cm-menu[open]');
    if (open) { open.removeAttribute('open'); open.querySelector('summary').focus(); }
  });

  // Handwritten note: characters left.
  document.querySelectorAll('[data-count-limit]').forEach(function (field) {
    var limit = parseInt(field.getAttribute('data-count-limit'), 10);
    var out = field.closest('.cm-giftnote').querySelector('[data-count]');
    function update() { if (out) out.textContent = String(limit - field.value.length); }
    field.addEventListener('input', update);
    update();
  });

  // Closures (Bowhouse market weekends, times away), from Shopify: Content → Metaobjects → Closures.
  var closures = [];
  try { closures = JSON.parse((document.getElementById('cormo-closures') || {}).textContent || '[]'); } catch (e) { closures = []; }
  var DAY = 86400000;
  var ukParts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
  var uk = function (t) { var p = ukParts.find(function (x) { return x.type === t; }); return p ? +p.value : 0; };
  var today = new Date(Date.UTC(uk('year'), uk('month') - 1, uk('day')));
  var hourNow = uk('hour') % 24;
  var pad2 = function (n) { return (n < 10 ? '0' : '') + n; };
  var ymd = function (d) { return d.toISOString().slice(0, 10); };
  var longDate = function (d) { return new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(d); };
  var coveredBy = function (d) {
    var k = ymd(d);
    for (var i = 0; i < closures.length; i++) { var c = closures[i]; if (c.start && c.end && c.start <= k && k <= c.end) return c; }
    return null;
  };

  // Away: pause ordering across the site (the banner may already be there from the server).
  var awayNow = closures.filter(function (c) { return c.kind === 'Away' && c.start <= ymd(today) && ymd(today) <= c.end; })[0];
  if (awayNow) {
    document.body.classList.add('is-away');
    var banner = document.querySelector('[data-away-banner]');
    if (banner && banner.hidden) {
      var back = new Date(Date.parse(awayNow.end + 'T00:00:00Z'));
      banner.querySelector('[data-away-text]').textContent = awayNow.message || ('We’re away until ' + longDate(back) + '. Ordering opens again when we’re back.');
      banner.hidden = false;
    }
  }

  // December ordering (Theme settings → December ordering): the posting phase in UK time, because pages are cached.
  // Phase 1: posted the next working day. Phase 2: posted by the set date. Phase 3: collection only.
  var dec = {};
  try { dec = JSON.parse((document.getElementById('cormo-december') || {}).textContent || '{}'); } catch (e) { dec = {}; }
  var todayKey = ymd(today);

  // Limited runs: an "Until [date]" line goes once its date has passed (UK time), so it is never out of date.
  document.querySelectorAll('[data-until]').forEach(function (el) {
    if (el.getAttribute('data-until') < todayKey) el.parentNode.removeChild(el);
  });
  var nowKey = todayKey + ' ' + pad2(hourNow) + ':' + pad2(uk('minute'));
  var decPhase = '';
  if (dec.on && dec.start && dec.end && dec.start <= todayKey && todayKey <= dec.end) {
    decPhase = todayKey <= dec.nextDayUntil ? '1' : (todayKey <= dec.lastOrder ? '2' : '3');
  }
  document.body.classList.toggle('is-december', decPhase !== '');
  ['1', '2', '3'].forEach(function (p) { document.body.classList.toggle('phase-' + p, decPhase === p); });

  // Basket, December: drop days whose orders have closed, keep the Delivery wording current, hold checkout until a choice.
  var whenSel = document.querySelector('[data-when]');
  if (whenSel) {
    Array.prototype.slice.call(whenSel.options).forEach(function (o) {
      var closes = o.getAttribute('data-closes');
      if (closes && nowKey > closes) o.parentNode.removeChild(o);
    });
    var postOpt = whenSel.querySelector('[data-kind="post"]');
    if (postOpt && decPhase === '2') postOpt.textContent = whenSel.getAttribute('data-post-by');
    var checkoutBtn = document.querySelector('#basket-form button[name="checkout"]');
    var whenHint = document.querySelector('[data-when-hint]');
    var whenClosed = document.querySelector('[data-when-closed]');
    var syncWhen = function () {
      var none = whenSel.options.length <= 1;
      var v = whenSel.value;
      if (checkoutBtn) checkoutBtn.disabled = none || v === '';
      if (none) {
        whenSel.hidden = true;
        if (whenHint) whenHint.hidden = true;
        if (whenClosed) whenClosed.hidden = false;
        return;
      }
      if (whenHint) whenHint.textContent = whenSel.getAttribute(v === '' ? 'data-hint-none' : (v === 'Post' ? 'data-hint-post' : 'data-hint-collect'));
    };
    whenSel.addEventListener('change', function () {
      syncWhen();
      post('cart/update.js', { attributes: { When: whenSel.value } }).catch(function () {});
    });
    syncWhen();
  }

  // Homepage phone video: fetched only on a phone. When it can't play (an iPhone in Low Power Mode refuses autoplay,
  // or it fails to load), or the visitor has asked for reduced motion, the video's last frame shows as a still if there
  // is one, so phones still open on the panettone; a tap then plays it (except with reduced motion). Visitors saving
  // data, and pages without stills, keep the photograph.
  var heroVideo = document.querySelector('[data-hero-video]');
  if (heroVideo && window.matchMedia) {
    var phone = window.matchMedia('(max-width: 900px)');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    var heroFig = heroVideo.closest('[data-hero]');
    var poster = heroVideo.getAttribute('data-poster');
    var endStill = heroVideo.getAttribute('data-end');
    var loadHero = function () {
      if (heroVideo.getAttribute('src')) return;
      var hls = heroVideo.getAttribute('data-hls');
      heroVideo.src = (hls && heroVideo.canPlayType('application/vnd.apple.mpegurl')) ? hls : heroVideo.getAttribute('data-mp4');
      heroVideo.muted = true;
    };
    var showEnd = function (tapToPlay) {
      if (!endStill) { heroFig.classList.remove('video-on'); return; }
      heroVideo.poster = endStill;
      heroFig.classList.add('video-on');
      if (!tapToPlay || heroFig.getAttribute('data-tap')) return;
      heroFig.setAttribute('data-tap', '1');
      heroFig.addEventListener('click', function () {
        loadHero();
        var p = heroVideo.play();
        if (p && p.catch) p.catch(function () {});
      });
    };
    var startHero = function () {
      if (!phone.matches || saveData || heroVideo.getAttribute('data-started')) return;
      heroVideo.setAttribute('data-started', '1');
      if (still) { showEnd(false); return; }
      heroVideo.addEventListener('playing', function () { heroFig.classList.add('video-on'); });
      heroVideo.addEventListener('error', function () { showEnd(false); });
      if (poster) { heroVideo.poster = poster; heroFig.classList.add('video-on'); }
      loadHero();
      var playing = heroVideo.play();
      if (playing && playing.catch) playing.catch(function () { showEnd(true); });
    };
    startHero();
    if (phone.addEventListener) phone.addEventListener('change', startHero);
  }

  // Sunday: the collection date in UK time, skipping closed Sundays, and the notice for the next market weekend.
  var dateEl = document.querySelector('[data-sunday-date]');
  if (dateEl) {
    var line = document.querySelector('[data-sunday-line]');
    var state = line ? line.getAttribute('data-sunday-line') : 'open';
    var dow = today.getUTCDay(); // 0 = Sunday
    if (state === 'open') {
      var sunday = new Date(today.getTime() + (dow === 0 ? 7 : 7 - dow) * DAY);
      dateEl.textContent = longDate(sunday);
    } else {
      // Pre-orders open on Monday at 1pm, for the Sunday after. Closed Sundays move it on a week.
      var toMonday = (8 - dow) % 7;
      if (dow === 1 && hourNow < 13) toMonday = 0;
      if (toMonday === 0 && dow === 1 && hourNow >= 13) toMonday = 7;
      var monday = new Date(today.getTime() + toMonday * DAY);
      var target = new Date(monday.getTime() + 6 * DAY);
      var skipped = false;
      for (var guard = 0; guard < 12 && coveredBy(target); guard++) { monday = new Date(monday.getTime() + 7 * DAY); target = new Date(target.getTime() + 7 * DAY); skipped = true; }
      if (skipped && line) {
        line.textContent = '';
        line.appendChild(document.createTextNode('Pre-orders for '));
        var strong = document.createElement('strong'); strong.className = 'date'; strong.textContent = longDate(target);
        line.appendChild(strong);
        line.appendChild(document.createTextNode(' open on ' + longDate(monday) + ' at 1pm.'));
      } else {
        dateEl.textContent = longDate(target);
      }
    }
    // The next market Sunday within three weeks gets a calm notice.
    var notice = document.querySelector('[data-closure-notice]');
    if (notice) {
      for (var n = 0; n <= 21; n++) {
        var d = new Date(today.getTime() + n * DAY);
        if (d.getUTCDay() !== 0) continue;
        var c = coveredBy(d);
        if (!c) continue;
        notice.querySelector('[data-closure-title]').textContent = 'No collection on ' + longDate(d);
        notice.querySelector('[data-closure-text]').textContent = c.message || (c.kind === 'Away' ? 'We’re away that week.' : 'We’re at the Bowhouse market that weekend.');
        notice.hidden = false;
        break;
      }
    }
  }

  // Basket, "To go with it": keep what's been typed (phone, note, day) before adding, then show the basket again.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-suggest-add]');
    if (!form) return;
    e.preventDefault();
    var basket = document.getElementById('basket-form');
    var attrs = {};
    if (basket) {
      ['Phone', 'Gift note', 'When'].forEach(function (k) {
        var el = basket.querySelector('[name="attributes[' + k + ']"]');
        if (el && el.value) attrs[k] = el.value;
      });
    }
    var id = parseInt(form.querySelector('[name="id"]').value, 10);
    document.querySelectorAll('[form="' + form.id + '"]').forEach(function (b) { b.disabled = true; });
    (Object.keys(attrs).length ? post('cart/update.js', { attributes: attrs }) : Promise.resolve())
      .then(function () { return post('cart/add.js', { items: [{ id: id, quantity: 1 }] }); })
      .then(function () { window.location.reload(); })
      .catch(function () { form.submit(); });
  });

  // Sunday: add to the basket without leaving the page, then keep the cards and the order slip in step.
  var slip = document.querySelector('[data-slip]');
  if (!slip) return;

  function nameOf(item) {
    var t = item.product_title || item.title;
    if (item.product_type === 'Panettone') {
      var w = t.indexOf('(1kg)') > -1 ? '1kg' : (t.indexOf('(750g)') > -1 ? '750g' : '');
      t = t.split(' Panettone')[0].split(' (')[0];
      if (w) t += ' · ' + w;
    }
    return t;
  }

  function render(cart) {
    var qtyByVariant = {};
    cart.items.forEach(function (i) { qtyByVariant[i.variant_id] = (qtyByVariant[i.variant_id] || 0) + i.quantity; });
    document.querySelectorAll('.scard[data-variant-id]').forEach(function (card) {
      var q = qtyByVariant[card.getAttribute('data-variant-id')] || 0;
      var add = card.querySelector('[data-sunday-add]');
      var step = card.querySelector('[data-stepper]');
      if (add) add.hidden = q > 0;
      if (step) { step.hidden = q === 0; step.querySelector('[data-qty]').textContent = String(q); }
    });
    var lines = slip.querySelector('[data-slip-lines]');
    lines.innerHTML = '';
    cart.items.forEach(function (i) {
      var row = document.createElement('div');
      row.className = 'slip-line';
      var a = document.createElement('span'); a.textContent = i.quantity + ' × ' + nameOf(i);
      var b = document.createElement('span'); b.textContent = money(i.final_line_price);
      row.appendChild(a); row.appendChild(b); lines.appendChild(row);
    });
    var has = cart.item_count > 0;
    slip.querySelector('[data-slip-total]').hidden = !has;
    slip.querySelector('[data-slip-total-value]').textContent = money(cart.total_price);
    slip.querySelectorAll('[data-slip-review]').forEach(function (el) { el.hidden = !has; });
    slip.querySelector('[data-slip-empty]').hidden = has;
    var bar = slip.querySelector('[data-slip-bar]');
    if (has) bar.textContent = cart.item_count + (cart.item_count === 1 ? ' item · ' : ' items · ') + money(cart.total_price);
    var basket = document.querySelector('.cm-header-basket');
    if (basket) basket.textContent = has ? 'Basket (' + cart.item_count + ')' : 'Basket';
  }

  function refresh() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(render);
  }

  function post(url, body) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-sunday-add]');
    if (!form) return;
    e.preventDefault();
    var id = parseInt(form.querySelector('[name="id"]').value, 10);
    form.querySelector('button').disabled = true;
    post('cart/add.js', { items: [{ id: id, quantity: 1 }] })
      .then(refresh)
      .catch(function () { window.location.reload(); })
      .finally(function () { form.querySelector('button').disabled = false; });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-stepper] [data-delta]');
    if (!btn) return;
    var card = btn.closest('.scard');
    var id = card.getAttribute('data-variant-id');
    var current = parseInt(card.querySelector('[data-qty]').textContent, 10) || 0;
    var next = Math.max(0, current + parseInt(btn.getAttribute('data-delta'), 10));
    btn.disabled = true;
    post('cart/change.js', { id: String(id), quantity: next })
      .then(render)
      .catch(function () { window.location.reload(); })
      .finally(function () { btn.disabled = false; });
  });

  // Email sign-ups reload the page at the top. Bring the form that was used back into view, so the
  // thank-you line is seen (the footer's especially).
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('.cm-drop');
    if (f && f.id) { try { sessionStorage.setItem('cm-signup', f.id); } catch (err) {} }
  });
  if (/[?&]customer_posted=true/.test(window.location.search)) {
    var used = null;
    try { used = sessionStorage.getItem('cm-signup'); sessionStorage.removeItem('cm-signup'); } catch (err) {}
    var usedForm = used && document.getElementById(used);
    if (usedForm) usedForm.scrollIntoView({ block: 'center' });
  }
})();
